import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const BlogCategoryShow = () => {
  const location = useLocation();
  const Navigate = useNavigate();
  const [name, setName] = useState("");
  const [status, setStatus] = useState("");

  useEffect(() => {
    if (location?.state === null || location?.state === undefined) {
      Navigate("/admin/blog-category");
    } else {
      setName(location?.state?.name ?? location?.state?.category ?? "");
      setStatus(location?.state?.status);
    }
  }, []);

  return (
    <div className="al">
      <div className="al-head">
        <div>
          <h1 className="al-title">Blog Category Details</h1>
          <p className="al-sub">View this blog category.</p>
        </div>
        <div className="al-head__actions">
          <button type="button" className="al-btn" onClick={() => Navigate(-1)}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6" /></svg>
            Back
          </button>
        </div>
      </div>

      <div className="al-idbanner">
        <div className="al-idbanner__icon">
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20.59 13.41 13.42 20.6a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" /><line x1="7" y1="7" x2="7.01" y2="7" /></svg>
        </div>
        <div>
          <div className="al-idbanner__name">{name || "—"}</div>
          <div className="al-idbanner__sub">Blog Category</div>
        </div>
        <span className="al-pill" style={{ marginLeft: "auto", background: status ? "var(--color-success-bg)" : "var(--color-surface-2)", color: status ? "var(--color-success-text)" : "var(--color-text-secondary)" }}>
          {status ? "Active" : "Deactive"}
        </span>
      </div>

      <div className="al-card">
        <div className="al-cardhead">
          <div className="al-cardhead__icon"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20.59 13.41 13.42 20.6a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" /><line x1="7" y1="7" x2="7.01" y2="7" /></svg></div>
          <h3 className="al-cardhead__title">Specification</h3>
        </div>
        <div className="al-spec">
          <div>
            <div className="al-spec__lbl">Name</div>
            <div className="al-spec__val">{name || "—"}</div>
          </div>
          <div>
            <div className="al-spec__lbl">Status</div>
            <div className="al-spec__val">
              <span className="al-pill" style={{ background: status ? "var(--color-success-bg)" : "var(--color-surface-2)", color: status ? "var(--color-success-text)" : "var(--color-text-secondary)" }}>
                {status ? "Active" : "Deactive"}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogCategoryShow;
